import {
  GET_SWAP_AGENT_ADMIN_ERROR,
  GET_SWAP_AGENT_ADMIN_LOADING,
  GET_SWAP_AGENT_ADMIN_SUCCESS,
  RESET_GET_SWAP_AGENT_ADMIN,
} from "../type/Constant";

let initialState = {
  getswapagent: {
    loading: false,
    data: null,
    error: false,
    errors: null,
    success: false,
    pagination: {},
  },
};

export default function getSwapAgentAdminReducer(state = initialState, action) {
  switch (action.type) {
    case GET_SWAP_AGENT_ADMIN_LOADING:
      return {
        ...state,
        getswapagent: {
          ...state.getswapagent,
          loading: true,
          error: false,
          errors: [],
          success: false,
        },
      };

    case GET_SWAP_AGENT_ADMIN_SUCCESS:
      return {
        ...state,
        getswapagent: {
          ...state.getswapagent,
          loading: false,
          error: false,
          errors: [],
          success: true,
          data: action.response.data,
          pagination: action.pagination,
        },
      };

    case GET_SWAP_AGENT_ADMIN_ERROR:
      return {
        ...state,
        getswapagent: {
          ...state.getswapagent,
          loading: false,
          error: true,
          errors: action.errors,
          success: false,
          data: null,
        },
      };

    case RESET_GET_SWAP_AGENT_ADMIN:
      return {
        ...state,
        getswapagent: {
          ...state.getswapagent,
          loading: false,
          error: false,
          errors: false,
          success: false,
          data: null,
        },
      };

    default:
      return state;
  }
}
